import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { environment } from 'src/main/environments';
import { EnvironmentInformationComponent } from '../../environment-information/environment-information.component';
import { NavbarComponent } from '../../navbar/navbar.component';
import { SidebarComponent } from '../../sidebar/sidebar.component';

@Component({
  selector: 'core-layout-header',
  templateUrl: './header.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [EnvironmentInformationComponent, NavbarComponent],
})
export class LayoutHeaderComponent {
  @ViewChild(SidebarComponent) sidebar!: SidebarComponent;

  environment = environment;

  toggleSidebar() {
    this.sidebar?.toggleSidebar();
  }
}
